var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlackicon = function SvgSlackicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.422
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e01e5a",
    stroke: "#e01e5a",
    strokeWidth: 0.395625,
    d: "M9.334 19.895c0-1.748 1.322-3.154 2.963-3.154 1.64 0 2.962 1.406 2.962 3.154v7.768c0 1.748-1.321 3.154-2.962 3.154-1.64 0-2.963-1.406-2.963-3.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecb22d",
    stroke: "#ecb22d",
    strokeWidth: 0.395625,
    d: "M19.895 22.666c-1.748 0-3.154-1.322-3.154-2.963 0-1.64 1.406-2.962 3.154-2.962h7.768c1.748 0 3.154 1.322 3.154 2.962 0 1.64-1.406 2.963-3.154 2.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2fb67c",
    stroke: "#2fb67c",
    strokeWidth: 0.395625,
    d: "M16.74 4.338c0-1.749 1.323-3.155 2.963-3.155 1.64 0 2.963 1.406 2.963 3.155v7.767c0 1.748-1.322 3.154-2.963 3.154-1.64 0-2.962-1.406-2.962-3.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36c5f1",
    stroke: "#36c5f1",
    strokeWidth: 0.395625,
    d: "M4.338 15.26c-1.749 0-3.155-1.322-3.155-2.963 0-1.64 1.406-2.963 3.155-2.963h7.767c1.748 0 3.154 1.322 3.154 2.963 0 1.64-1.406 2.962-3.154 2.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecb22d",
    stroke: "#ecb22d",
    strokeWidth: 0.395625,
    d: "M16.755 27.873a2.958 2.958 0 0 0 5.915 0 2.958 2.958 0 0 0-2.958-2.962h-2.957z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2fb67c",
    stroke: "#2fb67c",
    strokeWidth: 0.395625,
    d: "M27.873 15.26h-2.962v-2.963a2.958 2.958 0 0 1 5.916 0 2.958 2.958 0 0 1-2.954 2.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e01e5a",
    stroke: "#e01e5a",
    strokeWidth: 0.395625,
    d: "M4.145 16.755h2.963v2.962a2.958 2.958 0 0 1-5.916 0 2.958 2.958 0 0 1 2.953-2.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36c5f1",
    stroke: "#36c5f1",
    strokeWidth: 0.395625,
    d: "M15.26 4.145v2.963h-2.963a2.958 2.958 0 1 1 0-5.916 2.958 2.958 0 0 1 2.962 2.953z"
  }))));
};
export default SvgSlackicon;